export const kycBadge = {
  draft: { label: "Borrador", cls: "bg-slate-500/10 text-slate-400 border border-slate-500/20" },
  incomplete: { label: "Incompleto", cls: "bg-red-500/10 text-red-400 border border-red-500/20" },
  pending: { label: "Pendiente", cls: "bg-amber-500/10 text-amber-400 border border-amber-500/20" },
  pending_docs: { label: "Pend. Docs", cls: "bg-blue-500/10 text-blue-400 border border-blue-500/20" },
  pending_review: { label: "En revisión", cls: "bg-amber-500/10 text-amber-400 border border-amber-500/20" },
  verified: { label: "Verificado", cls: "bg-emerald-500/10 text-emerald-400 border border-emerald-500/20" },
  rejected: { label: "Rechazado", cls: "bg-red-500/10 text-red-400 border border-red-500/20" },
};

export const riskBadge = {
  low: { label: "Bajo", cls: "bg-emerald-500/10 text-emerald-400" },
  medium: { label: "Medio", cls: "bg-amber-500/10 text-amber-400" },
  high: { label: "Alto", cls: "bg-orange-500/10 text-orange-400" },
  critical: { label: "Critico", cls: "bg-red-500/10 text-red-400" },
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
